import { call, put, takeLatest } from "redux-saga/effects";
import {
  CREATE_COURSE_INSTANCE,
  setCourseInstance,
  UPDATE_COURSE_INSTANCE,
  updateCourseInstanceSuccess,
  createCourseInstanceError,
  updateCourseInstanceError,
} from "./start-course-instance.action";
import { AxiosResponse } from "axios";
import {
  deployCourseInstance,
  updateCourseInstance,
} from "./start-course-instance.service";
import { hideLoader, showLoader } from "../../store/model/model.action";

export default function* watchAnalyticsLoad() {
  yield takeLatest(CREATE_COURSE_INSTANCE, handleCreateCourseInstance);
  yield takeLatest(UPDATE_COURSE_INSTANCE, handleUpdateCourseInstance);
}

export const handleCreateCourseInstance = function* (requestParam: {
  type: string;
  payload: any;
}) {
  try {
    yield put(showLoader("Course deployment in progress"));
    const resultData: AxiosResponse<any> = yield call(
      deployCourseInstance,
      requestParam.payload
    );

    if (resultData && resultData.status === 200) {
      yield put(setCourseInstance(resultData));
    } else {
      const errorMessage =
        resultData?.data ||
        resultData?.data?.message ||
        resultData?.data?.error ||
        "Failed to create course instance. Please try again.";

      const errorPayload = {
        message: errorMessage,
        status: resultData?.status || 500,
        data: resultData?.data || null,
      };

      yield put(createCourseInstanceError(errorPayload));
    }
    yield put(hideLoader());
  } catch (error: any) {
    yield put(hideLoader());
    const errorMessage =
      error?.response?.data ||
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Failed to create course instance. Please try again.";

    const errorPayload = {
      message: errorMessage,
      status: error?.response?.status || 500,
      data: error?.response?.data || null,
    };

    yield put(createCourseInstanceError(errorPayload));
  }
};

export const handleUpdateCourseInstance = function* (requestParam: {
  type: string;
  payload: any;
}) {
  try {
    yield put(showLoader("Updating course instance..."));
    const resultData: AxiosResponse<any> = yield call(
      updateCourseInstance,
      requestParam.payload
    );

    if (resultData && resultData.status === 200) {
      yield put(updateCourseInstanceSuccess(resultData));
    } else {
      const errorMessage =
        resultData?.data?.message ||
        resultData?.data?.error ||
        "Failed to update course instance. Please try again.";

      const errorPayload = {
        message: errorMessage,
        status: resultData?.status || 500,
        data: resultData?.data || null,
      };

      yield put(updateCourseInstanceError(errorPayload));
    }
    yield put(hideLoader());
  } catch (error: any) {
    yield put(hideLoader());
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Failed to update course instance. Please try again.";

    const errorPayload = {
      message: errorMessage,
      status: error?.response?.status || 500,
      data: error?.response?.data || null,
    };

    yield put(updateCourseInstanceError(errorPayload));
  }
};
